import EventEmitter from "eventemitter3";

export class GameScreen extends EventEmitter{
    private iframe:HTMLIFrameElement|null = null;
    constructor(){
        super()
        this.loadIframe();
    }
    protected setupScreen(): void{
        
    }

    public loadIframe(){
        const iframe = document.createElement("iframe");
        iframe.src = "https://slowroads-controller.pages.dev";
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.border = "none";

        this.iframe = iframe;
    }

    getElement(){
        return `<div id="game-screen-container" style="width:100vw;height:400px;"></div>`;
    }

    addEventListeners(){
        if (this.iframe) {
            const container = document.getElementById('game-screen-container');
            if (container) {
                container.appendChild(this.iframe);
            }
        }

        window.addEventListener('message', (event) => {
            console.log("Message received from iframe:", JSON.stringify(event.data));
            if (event.data.type === 'requestOrientation'){
                (Android as any).sendMessage("orientation.pitch");
            }else if(event.data === 'accelerate_on'){
                console.log("accelerate on event received");
                this.emit("accelerate_on");
            }else if(event.data === 'accelerate_off'){
                this.emit("accelerate_off");
            }else if(event.data === 'brake_on'){
                this.emit("brake_on");
            }else if(event.data === 'brake_off'){
                this.emit("brake_off");
            }
        })
    }
}